module.exports = __webpack_public_path__ + "static/media/biometric-assessment.9e90d264.png";